import { useContext } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableFooter, Typography } from '@mui/material';
import { ticketCategoriesContext } from '../TicketCategoriesContext';
import { CircleLoader, DeleteIconButton, EditIconButton } from 'components';
import { localeManagerContext } from 'helpers/Locale';

let Results = () => {

    let localeManager = useContext(localeManagerContext);
    let service = useContext(ticketCategoriesContext);


    return (
        <>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <PerfectScrollbar>
                    <div style={{ minWidth: 700 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nome</TableCell>
                                    <TableCell>Colore</TableCell>
                                    <TableCell>Utenti di default per app MySimec</TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {service.categories.map((category, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell>{category.name[localeManager.currentLocale]}</TableCell>
                                        <TableCell>
                                            <div style={{ backgroundColor: category.color, width: 100, height: 20 }} />
                                        </TableCell>
                                        <TableCell>{category.defaultNotification}</TableCell>
                                        <TableCell align="right">
                                            <EditIconButton link={`/ticketcategory/edit/${category.ticketCategoryId}`} />
                                            <DeleteIconButton onClick={() => service.deleteTicketCategory(category.ticketCategoryId)} />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                            {service.categories.length === 0 &&
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={4}>
                                            <Typography variant="subtitle2">Nessuna categoria trovata</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableFooter>
                            }
                        </Table>
                    </div>

                    <TablePagination
                        component="div"
                        count={service.recordCount}
                        onPageChange={service.handleChangePage}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                        labelDisplayedRows={({ page }) =>
                            <span>Pagina {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                        }
                    />
                </PerfectScrollbar>
            }
        </>
    );
}

export default Results;